import { listingQuery } from "@/api/listings";
import { queryClient } from "@/api/utils";
import { ListingEditorLayout } from "@/components/listing-editor";
import { seo } from "@/utils/seo";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/listings/$listingId/$version")({
  component: ListingPage,
  beforeLoad: () => ({
    breadcrumb: "Edit Listing",
  }),
  parseParams: ({ version, ...params }) => {
    const num = +version;
    if (!isFinite(num)) {
      throw new Error("Invalid listing version");
    }
    return {
      ...params,
      version: Math.round(num),
    };
  },
  stringifyParams: ({ version, ...params }) => ({
    ...params,
    version: version.toString(),
  }),
  loader: async ({ params }) => {
    queryClient.removeQueries(listingQuery(params.listingId, params.version));
    await queryClient.prefetchQuery(listingQuery(params.listingId, params.version));
  },
  // Do not cache this route's data after it's unloaded
  gcTime: 0,
  // Only reload the route when the user navigates to it or when deps change
  shouldReload: false,
  head: () => ({ meta: seo({ title: "Edit Listing" }) }),
});

function ListingPage() {
  const { listingId, version } = Route.useParams();

  return (
    <ListingEditorLayout listingId={listingId} version={version}>
      <Outlet />
    </ListingEditorLayout>
  );
}
